export default __webpack_public_path__ + "static/media/pic_ai_5.e8e69636.png";